import { render, staticRenderFns } from "./EmailNotificationView.vue?vue&type=template&id=42cba6dc&scoped=true&"
import script from "./EmailNotificationView.vue?vue&type=script&lang=js&"
export * from "./EmailNotificationView.vue?vue&type=script&lang=js&"
import style0 from "./EmailNotificationView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EmailNotificationView.vue?vue&type=style&index=1&id=42cba6dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cba6dc",
  null
  
)

export default component.exports